import React from 'react';
import { useSelector } from 'react-redux';

import { selectors } from 'state';

import LegacyMarketsTab from '../MarketsTab';
import AllMarketsBoard from '../MarketsTabV2/MarketBoard';
import SplitDeskBoard from '../MarketsTabV3/MarketBoard';
import MarketBoard from './MarketBoard';
import { MARKETS_ASSESSMENT_PREVIEW_ENABLED } from './assessmentMode';
import { readMarketsExperience } from './model';
import '../MarketsTabV3/marketsTabV3.css';
import './marketsTabV4.css';

const ignoreExperienceChange = () => undefined;

/**
 * Session-selected Markets experiences. Classic stays the safe default and
 * every alternate surface remains an explicit blueprint/session opt-in.
 */
const MarketsTabV4: React.FC = () => {
  const session = useSelector(selectors.activeSession);
  const experience = readMarketsExperience(session?.which_markets);

  if (!session?.id || experience === 'classic') return <LegacyMarketsTab />;

  if (experience === 'board') {
    return (
      <div className="markets-v4-pickerless-host">
        <AllMarketsBoard
          experience="board"
          onExperienceChange={ignoreExperienceChange}
        />
      </div>
    );
  }

  if (experience === 'desk') return <SplitDeskBoard />;

  return (
    <MarketBoard
      assessmentPreviewEnabled={MARKETS_ASSESSMENT_PREVIEW_ENABLED}
    />
  );
};

export default MarketsTabV4;
